import { atom } from 'jotai'
import { Quote } from 'types/payments'
import { WalletType } from 'types/types'
import { ConvertStep } from 'types/walletActions'
import { ConvertDetailsFormData } from '../schemas/convertDetailsSchema'

export const convertStepAtom = atom<ConvertStep>(ConvertStep.DETAILS)
export const convertFromWalletAtom = atom<WalletType>()
export const convertToWalletAtom = atom<WalletType>()
export const quoteEstimateAtom = atom<Quote>()
export const quoteAtom = atom<Quote>()
export const convertFormValuesAtom = atom<ConvertDetailsFormData>()
